<template>
    <div v-if="additionals">
        <rkm-data-table
            :fields="fields"
            :repository="repositories.cadastroCampanha"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="!!row.item.desativado"
                    @click="handleEdit(row.item.id)"
                    authorize="update-imunizacao-cadastro-campanha"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!row.item.desativado"
                    @click="handleDestroy(row.item)"
                    authorize="destroy-imunizacao-cadastro-campanha"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>
    </div>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            const fields = [
                { key: 'nome', label: 'Nome da campanha', name: 'imunizacaoCampanha.nome', searchable: true, sortable: true },
                { key: 'periodoDe', label: 'Periodo de', name: 'imunizacaoCampanha.periodoDe', searchable: true, sortable: true },
                { key: 'periodoAte', label: 'Periodo até', name: 'imunizacaoCampanha.periodoAte', searchable: true, sortable: true },
            ]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina', name: 'cadastroVacina.abreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina', name: 'cadastroVacina.sigla', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina', name: 'cadastroVacina.siglaNome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina', name: 'cadastroVacina.siglaAbreviacao', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina', name: 'cadastroVacina.abreviacaoNome', searchable: true, sortable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina', name: 'cadastroVacina.siglaAbreviacaoNome', searchable: true, sortable: true })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina', name: 'cadastroVacina.nome', searchable: true, sortable: true })
                    break;
            }

            fields.push(
                { key: 'meta', label: 'Meta', name: 'imunizacaoCampanha.meta', searchable: true, sortable: true },
                { class: 'col-min text-center', key: 'actions', label: 'Ações' }
            )

            return fields
        },
    },
    created() {
        this.repositories = {
            cadastroCampanha: this.getConectaSusRepository('imunizacao.cadastroCampanha')
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.cadastroCampanha.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEdit(id) {
            this.$router.push({ name: 'imunizacao-cadastro-campanha-edit', params: { id: id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastroCampanha.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a campanha?', destroy)
        },
    },
    mixins: [ repository ],
    mounted() {
        this.load()
    },
}
</script>